import type { PageRoute } from '../../page-route';
import { Login } from './page';

export const route: PageRoute = { path: '/login', access: 'public', Component: Login };
